import { render } from "./Navbar.vue?vue&type=template&id=1a07e847&ts=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__